/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerComponent } from './color-picker.component';
// import { ColorPickerWithPaletteComponent } from "./color-picker-with-palette.component";
// import { ColorPaletteComponent } from "./color-palette.component";
// import { ColorPickerWithAlphaComponent } from "./color-picker-with-alpha.component";

@NgModule({
	declarations: [
		ColorPickerComponent,
		// ColorPickerWithPaletteComponent,
		// ColorPaletteComponent,
		// ColorPickerWithAlphaComponent
	],
	imports: [ReactiveFormsModule],
	exports: [
		ColorPickerComponent,
		// ColorPickerWithPaletteComponent,
		// ColorPaletteComponent,
		// ColorPickerWithAlphaComponent
	],
	providers: [],
})
export class ColorPickerModule {}
